<template>
    <div class="get-info-container">
      <div class="get-info-content-header">
        <p style="height: 30px;" v-if="channel == 'fh'"></p>
        <img src="//assets/img/logo_l.png" alt="logo" v-else>
        <p class="header-title">申请免费体验</p>
        <p class="header-content">立即申请，免费体验，一对一指导</p>
      </div>
      <el-form ref="form" :model="form" label-width="0" :rules="rules" :show-message="false">
        <el-form-item prop="companyName">
          <el-input v-model="form.companyName" placeholder="请输入企业名称"></el-input>
        </el-form-item>
        <el-form-item prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="postName">
          <el-input v-model="form.postName" placeholder="请输入职位"></el-input>
        </el-form-item> -->
        <!-- <el-form-item prop="province">
          <el-select v-model="form.province" placeholder="请选择省份">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item class="img-code-content" prop="verifyKey" v-if="isShowVerifyKey">
          <el-input v-model="captcha" placeholder="请输入图形验证码"></el-input>
          <img :src="'data:image/png;base64,'+verifyKeyBase64" alt="验证码" @click="getVerifyKey">
        </el-form-item>
        <el-form-item class="phone-code-content" prop="captcha">
          <el-input v-model="form.captcha" placeholder="请输入验证码"></el-input>
          <el-button @click="countDown" :disabled="disablePhoneCodeBtn" type="primary">{{ btnContent }}</el-button>
        </el-form-item>
      </el-form>
      <div class="get-info-content-footer">
        <el-button class="submit-btn" type="primary" @click="onSubmit">申请体验</el-button>
        <p>申请即视为同意<span onclick="window.open('https://account.glodon.com/privacy')">《隐私协议》</span>和<span onclick="window.open('https://account.glodon.com/agreement')">《用户协议》</span></p>
      </div>
    </div>
  </template>
  
  <script>
  import servers from './servers';
  const phoneReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
  export default {
    name: 'GetInfo',
    props: {
        channel: {
            type: String
        },
        operationCode: {
            type: String,
        }
    },
    data () {
        return {
            btnContent: '获取验证码',
            totalTime: 60,
            disablePhoneCodeBtn: false,
            form: {
                companyName: '',
                name: '',
                // postName: '',
                // province: '',
                phone: '',
                captcha: '',
            },
            isShowVerifyKey: false,
            verifyKey: '',
            captcha: '',
            verifyKeyBase64: '',
            rules: {
                companyName: [{ required: true, message: '', trigger: 'blur' },],
                name: [{ required: true, message: '', trigger: 'blur' },],
                postName: [{ required: true, message: '', trigger: 'blur' },],
                province: [{ required: true, message: '', trigger: 'blur' },],
                phone: [
                    { required: true, message: '', trigger: 'blur' },
                    { pattern: phoneReg, message: '' }
                ],
                captcha: [{ required: true, message: '', trigger: 'blur' },],
            },
            phoneReg: phoneReg,
            options: [],
        }
    },
    watch: {
        // operationCode(value) {
        //     if (value) {
        //         this.getProvince()
        //     }
        // }
    },
    methods: {
        async countDown() {
            if (this.checkData()) {
                return
            }
            this.disablePhoneCodeBtn = true
            // 发请求
            let responseData = await servers.getPhoneCaptcha({
                phone: this.form.phone,
                verifyKey: this.verifyKey,
                captcha: this.captcha
            });
            if (responseData.code === '0') {
                this.btnContent = this.totalTime + 's后重新发送'
                let clock = window.setInterval(() => {
                    this.totalTime--
                    this.btnContent = this.totalTime + 's后重新发送'
                    if (this.totalTime < 0) {
                        window.clearInterval(clock)
                        this.btnContent = '重发送验证码'
                        this.totalTime = 60
                        this.disablePhoneCodeBtn = false
                    }
                }, 1000)
            } else if (responseData.code === '1') {
                this.disablePhoneCodeBtn = false
                this.isShowVerifyKey = true
                this.captcha = ''
                this.verifyKey = responseData.data.verifyKey
                this.verifyKeyBase64 = responseData.data.image
                this.$message({
                    type: 'warning',
                    message: responseData.message
                })
            } else {
                this.$message({
                    type: 'warning',
                    message: responseData.message
                })
            }
            // ---------
            
        },
        async getVerifyKey() {
            let responseData = await servers.refreshCaptcha();
            this.verifyKeyBase64 = responseData.data.image
            this.verifyKey = responseData.data.verifyKey
        },
        async getProvince() {
            let responseData = await servers.getProvince();
            this.options = responseData;
        },
        async onSubmit() {
            if (this.disableSubmitBtn) {
                return
            }
            const valid = await this.$refs.form.validate();
            if (valid) {
                try {
                    this.disableSubmitBtn = true
                    let data = await servers.commit({
                        ...this.form,
                        channel: this.channel
                    });
                    if (data.code === '0') {
                        this.$emit('updateIsSubmit')
                    } else {
                        this.$message({
                            type: 'warning',
                            message: data.message
                        })
                    }
                } catch(err) {
                    console.log(err)
                }
                this.disableSubmitBtn = false
            }
        },
        checkData() {
            if (this.disablePhoneCodeBtn) {
                return true
            }
            // 校验手机号
            if (!this.phoneReg.test(this.form.phone)) {
              this.$message({
                type: 'warning',
                message: '请输入正确的手机号！'
              })
              return true
            }
            if (this.isShowVerifyKey && !this.captcha) {
                this.$message({
                    type: 'warning',
                    message: '请输入图形验证码！'
                })
                return true
            }
            return false
        }
    },
    created() {
        // if(this.operationCode && !this.options.lenght) {
        //     this.getProvince()
        // }
    },
    mounted() {
      // alert(document.querySelector('#app').offsetWidth)
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    .get-info-container {
      width: 400px;
      /* height: 1000px; */
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 0.32rem;
      padding: 0.2rem 0.5rem;
      border: 1px solid #ccc;
      background-color: #FFFFFF;
      border-radius: 0.08rem;
    }
    .get-info-content-header {
      margin-bottom: 0.2rem;
    }
    .get-info-content-header img {
      display: block;
      max-width: 3.2rem;
      margin-top: 0.4rem;
    }
    .header-title {
      width: 100%;
      font-weight: 600;
      font-size: 0.46rem;
      text-align: center;
      margin: 0.2rem 0;
    }
    .header-content {
      width: 100%;
      color: #666;
    }

    .img-code-content img {
      width: 2.4rem;
      min-width: 2.4rem;
      max-height: 0.72rem;
      margin-left: 0.2rem;
      overflow: hidden;
    }

    .get-info-content-footer {
      margin-bottom: 0.2rem;
    }
    .get-info-content-footer p {
      font-size: 0.25rem;
      line-height: 0.5rem;
    }
    .get-info-content-footer p span {
      color: #0082DC;
      cursor: pointer;
    }
    .submit-btn {
      width: 100%;
      background: linear-gradient(90deg, #0082DC 0%, #64C800 100%);
      border-radius: 5px;
      margin: 0.1rem auto;
      color: #FFFFFF;
      font-size: 0.38rem;
      border-radius: 0.08rem;
      letter-spacing: 0.1rem;
    }
  </style>
  
